import { saveClicked, loadVisited } from './links.js'

document.addEventListener('DOMContentLoaded', () => {
  filterList()
  loadVisited(true)
  saveClicked(true)
  
  const uwb = new UWB({
    uaTabletViewport: {
      init: true,
      width: 1140,
    },
    toolFixedHorizontalScroll: false,
  });

  UWX.MenuNth('.tab_select li', '.ca-index-inner>div', 'active');
  UWX.SearchParamAccess('tab', [
    { param: 'books', selector: '.tab_select .books'},
    { param: 'pages', selector: '.tab_select .pages'},
  ]);
  UWX.SearchParamURL('tab', [
    { param: 'books', selector: '.tab_select .books'},
    { param: 'pages', selector: '.tab_select .pages'},
  ], 'active');
});

const filterList = () => {
  UWX.RadioClass('.ca-index-sort li', 'active');
  Array.from(document.querySelectorAll('.ca-index-sort li')).forEach(li => {
    li.addEventListener('click', () => {
      const actived = document.querySelector('.ca-index-sort li.active')
      if(actived === li){
        return
      }

      li.classList.add('active')
      const filter = Array.from(li.classList).find(c => c.startsWith('filter_'))
      const hideItems = Array.from(document.querySelectorAll('.ca-index-pages_list li.hide'))
      hideItems.forEach(item => {
        item.classList.remove('hide')
      })
      const priorityCopy = Array.from(document.querySelectorAll('.ca-index-pages_list li.pri-copy'))
      priorityCopy.forEach(item => {
        item.parentElement.removeChild(item)
      })

      if(filter === 'filter_all'){
        return
      }

      const items = Array.from(document.querySelectorAll(`.ca-index-pages_list li`))
      items.forEach(item => {
        if(!item.classList.contains(filter.replace('filter_', ''))){
          item.classList.add('hide')
        }
      })

      if(filter === 'filter_happy'){
        filterHappyPriority()
      }
    })
  })
}

const happyPriority = ['pri-page','pri-kitomi', 'pri-map']
const filterHappyPriority = () => {
  happyPriority.slice().reverse().forEach(pri => {
    const items = Array.from(document.querySelectorAll(`.ca-index-pages_list li.happy.${pri}`))
    for(let i = items.length - 1; -1 < i; i--){
      const copy = items[i].cloneNode(true)
      copy.classList.add('pri-copy')
      items[i].classList.add('hide')
      items[i].parentElement.insertAdjacentElement('afterbegin', copy)
    }
  })







}
